import type React from 'react';

// Disco/music light bulb icon path extracted from Nightlife.svg
export const NIGHTLIFE_ICON_PATH = `<path fill-rule="evenodd" clip-rule="evenodd" d="M13.2255 3.83916C13.5212 3.51888 13.294 3.00002 12.8581 3.00002H11.0604L11.9097 1.78677C12.0681 1.56055 12.013 1.24878 11.7868 1.09043C11.5606 0.93207 11.2488 0.987087 11.0905 1.21331L9.83976 3.00002H3.1421C2.70622 3.00002 2.47905 3.51888 2.7747 3.83916L7.50169 8.96008C7.50065 8.97326 7.50012 8.98658 7.50012 9.00003V13H5.50012C5.22398 13 5.00012 13.2239 5.00012 13.5C5.00012 13.7762 5.22398 14 5.50012 14H10.5001C10.7763 14 11.0001 13.7762 11.0001 13.5C11.0001 13.2239 10.7763 13 10.5001 13H8.50012V9.00003C8.50012 8.98659 8.49959 8.97327 8.49855 8.9601L13.2255 3.83916ZM9.66042 5.00002H10.793L11.7161 4.00002H10.3604L9.66042 5.00002ZM9.13976 4.00002L8.43976 5.00002H5.20717L4.28409 4.00002H9.13976Z" fill="white"/>`;

export type NightlifeIconProps = {
  size?: number;
  color?: string;
  className?: string;
};

/**
 * Music/disco light bulb icon for POI markers
 *
 * Designed for 16x16px display within 24x24px circular backgrounds
 */
export const NightlifeIcon: React.FC<NightlifeIconProps> = ({ size = 16, color = 'currentColor', className }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.2255 3.83916C13.5212 3.51888 13.294 3.00002 12.8581 3.00002H11.0604L11.9097 1.78677C12.0681 1.56055 12.013 1.24878 11.7868 1.09043C11.5606 0.93207 11.2488 0.987087 11.0905 1.21331L9.83976 3.00002H3.1421C2.70622 3.00002 2.47905 3.51888 2.7747 3.83916L7.50169 8.96008C7.50065 8.97326 7.50012 8.98658 7.50012 9.00003V13H5.50012C5.22398 13 5.00012 13.2239 5.00012 13.5C5.00012 13.7762 5.22398 14 5.50012 14H10.5001C10.7763 14 11.0001 13.7762 11.0001 13.5C11.0001 13.2239 10.7763 13 10.5001 13H8.50012V9.00003C8.50012 8.98659 8.49959 8.97327 8.49855 8.9601L13.2255 3.83916ZM9.66042 5.00002H10.793L11.7161 4.00002H10.3604L9.66042 5.00002ZM9.13976 4.00002L8.43976 5.00002H5.20717L4.28409 4.00002H9.13976Z"
        fill={color}
      />
    </svg>
  );
};
